const range = [{
    content: `<span class="range mb-2">
                    <mark class="custom">  TRANSFORME </mark>
                 </span>
                 <span>
                     o complicado 
                 </span>
                 <span>
                     em <strong>simples</strong>
                 </span>`,
},
{
    content: `
    <span> <strong>CONTRIBUA</strong></span>
    <span>com <u>pequenas</u></span>
    <span>coisas que</span>
    <span class="range">
                    <mark class="light"> fazem a diferença</mark>
                 </span>`,

},
{
    content: `
    <span>Crie um <strong>ambiente</strong></span>
    <span class="range"><mark class="custom">PARTICIPATIVO</mark></span>
    <span>onde a alegria</span>
    <span><u>seja contagiante</u></span></span>
    `,
},
{
    content: `
    <span><strong>RECONHEÇA </strong> seus </span>
    <span class="range mt-2 mb-1"><mark class="light">talentos & dificuldades</mark></span>
    <span> e busque aprendizado </span>
    <span>e conhecimento </span>
    `,
},
{
    content: `
    <span> Se <u class="primary">coloque</u>  </span>
    <span>no lugar do</span>
    <span><strong>SEU CLIENTE</strong></span>
    `,
},
{
    content: `
    <span>Assuma a</span>
    <span><strong>responsabilidade</strong></span>
    <span>pelos seus</span>
    <span class="range mt-2"><mark class="custom">RESULTADOS</mark></span>
    `,
},

]

export { range }